import React, { useContext, useEffect, useRef, useState } from 'react';
import { MainContext } from '../context/main.context';
import { GAME_IFRAME_ID } from '../common/constants';
import { AUTH_EXIT, PAYMENT_EXIT } from '../common/errorCodes';
import { getIframeSrcOrigin } from '../common/tools';

const PAYMENT_PROVIDER_LIST: string[] = [
    'PaymentsYookassa',
    'PaymentsStripe',
    'PaymentsYandexPay',
    'PaymentsInqud',
]


export default function ModalGlobal() {
    const [ isVisible, setIsVisible ] = useState<boolean>(false);
    const [ hideCloseBtn, setHideCloseBtn ] = useState<boolean>(false);
    const [ isLoadData, setIsLoadData ] = useState<boolean>(true);

    const {
        modalContent,
        setModalContent,
        setSession,
        setSource,
        setLocale,
        setProject,
        setPaymentId,
        setJwt
    } = useContext(MainContext);

    useEffect(() => {
        if (modalContent) {
            setIsLoadData(true);
            setIsVisible(true);

            const displayName: string | undefined = modalContent?.component?.type?.displayName;

            if (displayName) {
                if (PAYMENT_PROVIDER_LIST.includes(displayName)) {
                    setHideCloseBtn(true);
                }
            } else {
                setHideCloseBtn(false);
            }

            const data: any = modalContent?.values;

            if (data) {
                _setData(data).then(() => setIsLoadData(false));
            } else {
                setIsLoadData(false);
            }
        }
    }, [ modalContent ]);

    useEffect(() => {
        return () => {
            _clearData();
        }
    }, []);

    const handleClose = () => {
        if (hideCloseBtn) {
            return;
        }

        const displayName: string | undefined = modalContent?.component?.type?.displayName;

        if (!displayName) {
            return;
        }

        const iframe = document.getElementById(GAME_IFRAME_ID) as HTMLIFrameElement | null;

        if (!iframe?.contentWindow) {
            return;
        }

        if (displayName === 'Payments') {
            _sendMessage(iframe, 'PLAYHUB_TO_IFRAME_PAYMENT_RESULT', 'payments', PAYMENT_EXIT);
        }

        if (displayName === 'Auth') {
            _sendMessage(iframe, 'PLAYHUB_TO_IFRAME_USER_AUTH', 'auth', AUTH_EXIT);
        }

        setIsVisible(false);
        setTimeout(() => setModalContent(null), 300);
    };

    const _setData = async (data: any) => {
        if (data?.session) {
            setSession(data.session);
        }

        if (data?.jwt) {
            setJwt(data.jwt);
        }

        if (data?.source) {
            setSource(data.source);
        }

        if (data?.locale) {
            setLocale(data.locale);
        }

        if (data?.project) {
            setProject(data.project);
        }

        if (data?.id) {
            setPaymentId(data.id);
        }
    };

    const _clearData = () => {
        setSession(null);
        setJwt(null);
        setSource(null);
        setLocale(null);
        setLocale(null);
        setProject(null);
    }

    const _sendMessage = (iframe: HTMLIFrameElement, type: string, eventType: string, errorCode: number) => {
        const text = JSON.stringify({
            data: {},
            type: eventType,
            isError: true,
            errorCode,
        });

        iframe.contentWindow!.postMessage({ type, text }, getIframeSrcOrigin());
    };

    if (!modalContent || isLoadData) {
        return null;
    }

    return (
        <div className={`modal-overlay ${isVisible ? 'visible' : ''}`} onClick={handleClose}>
            <div
                className={`modal-content-wrapper ${modalContent?.className ? modalContent.className : ''}`}
                onClick={(e) => e.stopPropagation()}
            >
                { modalContent.component }
            </div>
        </div>
    );
};


